'use client';

import { c as _c } from "react/compiler-runtime";
import { useAnalyticsSkuViewedContext } from '@repo/platform-analytics/AnalyticsSkuViewed/Context';
import { useElementInteracted } from '@repo/platform-analytics/hooks/useElementInteracted';
import { usePageAction } from '@repo/platform-analytics/hooks/usePageAction';
import type { TooltipActionType } from '@repo/platform-analytics/types';
export function useProductCardMobileAccordionPageAction() {
  const $ = _c(7);
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  let t0;
  if ($[0] !== skuImpressionId) {
    t0 = {
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[0] = skuImpressionId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const firePageAction = usePageAction(t0);
  let t1;
  if ($[2] !== skuImpressionId) {
    t1 = {
      entityName: "",
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[2] = skuImpressionId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const fireElementInteracted = useElementInteracted(t1);
  let t2;
  if ($[4] !== fireElementInteracted || $[5] !== firePageAction) {
    const fireTooltipPageAction = (actionType, actionName, actionSection) => {
      firePageAction({
        action_type: actionType,
        action_name: actionName,
        action_section: actionSection
      });
      fireElementInteracted({
        entity_name: actionName,
        interaction_type: actionType === "open" ? "expand" : "collapse",
        section_name: actionSection
      });
    };
    t2 = (actionType_0, actionName_0, actionSection_0) => {
      fireTooltipPageAction(actionType_0, actionName_0, actionSection_0);
    };
    $[4] = fireElementInteracted;
    $[5] = firePageAction;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleTooltipClickPageAction = t2;
  return handleTooltipClickPageAction;
}